import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { en } from "../translations/en";
import { gr } from "../translations/gr";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en-GB",
    debug: false,
    resources: {
      "en-GB": { translation: en },
      "en-US": { translation: en },
      GR: { translation: gr },
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
